<button id="work-packages-settings-button"
        title="{{ text.button_settings }}"
        class="button last work-packages-settings-button toolbar-icon"
        opSettingsContextMenu
        opSettingsContextMenu-query="query">
  <op-icon icon-classes="button--icon icon-show-more"></op-icon>
</button>
